var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLinkedin = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C13.2708 0 13.5 0.104167 13.6875 0.3125C13.8958 0.5 14 0.729167 14 1V13C14 13.2708 13.8958 13.5 13.6875 13.6875C13.5 13.8958 13.2708 14 13 14H1C0.729167 14 0.489583 13.8958 0.28125 13.6875C0.09375 13.5 0 13.2708 0 13V1C0 0.729167 0.09375 0.5 0.28125 0.3125C0.489583 0.104167 0.729167 0 1 0H13ZM4.21875 12H4.25V5.3125H2.15625V12H4.21875ZM2.34375 4.0625C2.57292 4.29167 2.85417 4.40625 3.1875 4.40625C3.52083 4.40625 3.80208 4.29167 4.03125 4.0625C4.28125 3.8125 4.40625 3.53125 4.40625 3.21875C4.40625 2.88542 4.28125 2.60417 4.03125 2.375C3.80208 2.125 3.52083 2 3.1875 2C2.85417 2 2.57292 2.125 2.34375 2.375C2.11458 2.60417 2 2.88542 2 3.21875C2 3.53125 2.11458 3.8125 2.34375 4.0625ZM12 12V8.34375C12 7.84375 11.9688 7.41667 11.9062 7.0625C11.8438 6.70833 11.7292 6.38542 11.5625 6.09375C11.3958 5.78125 11.1354 5.55208 10.7812 5.40625C10.4479 5.23958 10.0312 5.15625 9.53125 5.15625C9.05208 5.15625 8.63542 5.26042 8.28125 5.46875C7.94792 5.67708 7.70833 5.92708 7.5625 6.21875H7.53125V5.3125H5.53125V12H7.625V8.6875C7.625 8.16667 7.70833 7.75 7.875 7.4375C8.04167 7.125 8.36458 6.96875 8.84375 6.96875C9.09375 6.96875 9.30208 7.02083 9.46875 7.125C9.63542 7.22917 9.73958 7.38542 9.78125 7.59375C9.84375 7.80208 9.88542 7.98958 9.90625 8.15625C9.92708 8.30208 9.9375 8.5 9.9375 8.75V12H12Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/linkedin.8776a617.svg";
export { ForwardRef as ReactComponent };